import { useTranslation } from 'react-i18next';

export default function ClashLoadingState({ styles }) {
  const { t } = useTranslation('zodiacClash');
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.loadingSpinner} aria-label={t('loadingLabel')} />
      <div style={styles.loadingText}>{t('loading')}</div>
    </div>
  );
}
